import React from 'react';

interface TimeProps {
  /**
   * The date string to be displayed. Can be any valid date string parseable by Date.parse().
   */
  date: string;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;

  /**
   * Optional child elements to render inside the time element.
   */
  children?: React.ReactNode;
}

/**
 * Time component for displaying a date string in ISO format.
 * @param props The component props.
 * @returns JSX.Element
 */
export const Time: React.FC<TimeProps> = ({ date, className, children }) => {
  const timestamp = Date.parse(date);
  const dateObject = new Date(timestamp);
  const isoDate = dateObject.toISOString();

  return (
    <time dateTime={isoDate} className={className}>
      {children || date}
    </time>
  );
};
